import React, { useEffect, useCallback, useRef, useLayoutEffect } from "react"
import { useDebouncedCallback } from "use-debounce"

const DELAY = 100
const Div100vh: React.FC<React.PropsWithChildren> = ({ children, ...props }) => {
  const ref = useRef<HTMLDivElement>(null)
  const updateHeight = useCallback(() => {
    if (ref.current) {
      ref.current.style.height = `${window.innerHeight}px`
    }
  }, [])
  const onWindowResize = useDebouncedCallback(updateHeight, DELAY)

  // Update size after component is mounted
  useLayoutEffect(updateHeight, [updateHeight])

  useEffect(() => {
    window.addEventListener("resize", onWindowResize)
    return () => window.removeEventListener("resize", onWindowResize)
  }, [onWindowResize])

  return (
    <div {...props} ref={ref}>
      {children}
    </div>
  )
}

export default Div100vh
